import { CommonModule } from '@angular/common';
import { Component, inject, signal, viewChild } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { DxButtonModule, DxFormComponent, DxFormModule } from 'devextreme-angular';
import { ShamShamLogoFullIcon } from 'sham-components/icons';
import { ResetPasswordManager } from './reset-password-manager';
import { ResetPasswordPayload } from 'sham-components/shared/models/auth';

@Component({
  selector: 'app-reset-password',
  imports: [
    CommonModule,
    RouterLink,
    DxFormModule,
    DxButtonModule,
    ShamShamLogoFullIcon,
  ],
  providers: [ResetPasswordManager],
  templateUrl: './reset-password.html',
})
export class ResetPasswordComponent {
  private readonly route = inject(ActivatedRoute);
  readonly manager = inject(ResetPasswordManager);

  readonly loading = signal(false);
  readonly submitError = signal('');
  readonly submitSuccess = signal(false);

  readonly formData = signal<ResetPasswordPayload>({
    token: this.route.snapshot.queryParamMap.get('token') ?? '',
    password: '',
    confirmPassword: '',
  });

  readonly form = viewChild.required(DxFormComponent);

  readonly passwordEditorOptions = {
    mode: 'password',
    placeholder: 'New password',
    buttons: [
      {
        name: 'key',
        location: 'before',
        options: {
          icon: 'key',
          stylingMode: 'text',
          focusStateEnabled: false,
          elementAttr: {
            class: 'cursor-auto custom-icon-color pointer-events-none',
          },
        },
      },
    ],
  };

  readonly confirmPasswordEditorOptions = {
    mode: 'password',
    placeholder: 'Confirm password',
    buttons: [
      {
        name: 'key',
        location: 'before',
        options: {
          icon: 'key',
          stylingMode: 'text',
          focusStateEnabled: false,
          elementAttr: {
            class: 'cursor-auto custom-icon-color pointer-events-none',
          },
        },
      },
    ],
  };

  readonly passwordComparisonTarget = () => this.formData().password;

  async onSubmit() {
    const validation = this.form().instance.validate();

    if (!validation.isValid) {
      return;
    }

    if (!this.formData().token) {
      this.submitError.set('Invalid or missing reset token.');
      return;
    }

    this.loading.set(true);
    this.submitError.set('');

    await this.manager.submitForm(
      this.formData(),
      this.submitError,
      this.submitSuccess,
      this.loading,
    );
  }
}
